import { space } from './core'

const progressBar = {
  bar: {
    borderRadius: '40px',
    height: '6px',
    marginTop: `${space[3]}px`,
    position: 'relative'
  },
  progress: {
    height: '100%',
    transition: 'width .6s ease-out'
  },
  carWrapper: {
    position: 'absolute',
    top: '-10px',
    zIndex: 10,
    width: '100%'
  },
  flagWrapper: {
    position: 'absolute',
    top: '-23px',
    right: '5%'
  },
  finalFlagLeftWrapper: {
    svg: {
      '&:first-of-type': {
        position: 'absolute',
        top: '2px',
        zIndex: 0
      },
      '&:last-of-type': {
        zIndex: 1,
        position: 'relative'
      }
    }

  },
  finalFlagRightWrapper: {
    position: 'absolute',
    top: '6px',
    right: 0,
    zIndex: '10'
  }
}

export default progressBar
